const init = () =>{
    moveCart()
}

const moveCart = () => {
    if (window.innerWidth > 980) return;
    let cart = document.querySelector(".cart-wrapper")
    let searchBtn = document.querySelector(".et_pb_menu__icon.et_pb_menu__search-button")
    searchBtn.after(cart)
}

try {
    init()
} catch (error) {
    console.log(error)
}